import React from 'react'
import jsPDF from 'jspdf'
import logo from '../resource/logo.png'
function ReceiptPdf() {
    let pdfGenerate = () => {
        var doc = new jsPDF();
        doc.addImage(logo, 'PNG', 5, 5, 40, 20);

        
// doc.setFont("times", "normal");
// doc.text("This is centred text.", 105, 80, null, null, "center");
// doc.text("And a little bit more underneath it.", 105, 90, null, null, "center");
// doc.text("This is right aligned text", 200, 100, null, null, "right");
// doc.text("And some more", 200, 110, null, null, "right");
        // doc.setFont(18)
        doc.text('Digital Optimized & Tenacious Solutions', 200, 10, null, null, "right")
        doc.text('TBI cell, Block-3A, Chandigarh University Mohali, India', 200, 20, null, null, "right")

        doc.setLineWidth(0.1);
        doc.setDrawColor(0, 0, 0);
        doc.setLineDash([1, 1.5, 1, 1.5, 1, 1.5, 3, 2, 3, 2, 3, 2]);
        doc.line(10, 27, 200, 27);

        doc.setFontSize(16)
        doc.setTextColor(100);
        doc.text("Name: Pratik Gandhi",10,40)
        doc.text("Sub-total: 380.00",10,60)
        doc.text("Processing fee: 58.00",10,70)
        
        doc.setLineWidth(0.4);
        doc.line(10, 74, 100, 74);
        doc.text("Total: 480.00",10,85)
        
        
        doc.text("GST Registration No: 29AAQCS49E10Z",10,100)
        doc.text("Ref Id: 9034333842",10,110)

        doc.save('receipt.pdf')
    }
    return (
        <div>
            <button onClick={() => pdfGenerate()} type="button" class="btn btn-success">Download</button>
        </div>
    )
}

export default ReceiptPdf